export default __webpack_public_path__ + "static/media/imgSerologia.2072b0e1.png";